import Layout from "src/components/Layout/layout";

const TermsAndConditions = () => {
  return (
    <Layout>
      <section>
        <div className="container mx-auto bg-white rounded-md dark:bg-dark-bg-secondary ">
          <div className="p-4 articleWrapper">
            <p className="mb-2 font-semibold dark:text-dark-text-primary ">
              Terms Of Service
            </p>
            <p className="mb-2 text-sm dark:text-dark-text-secondary">
              This Master User Agreement constitutes a binding contract between
              you, the User, and XcelTrip LLC with regard to the use of various
              services that are provided by XcelTrip LLC
            </p>
            <ol className="pl-6 mb-2 text-sm list-disc dark:text-dark-text-secondary">
              <li className="mb-2 dark:text-dark-text-primary">
                XcelTrip LLC (“XcelTrip”), a company registered in Singapore,
                with its registered office at 10 Anson Rd, 10-11 International
                Plaza, Singapore 079903, provides various travel related
                services through its Website (www.XcelTrip.com), mobile-cellular
                technology as well as through its call center.
              </li>
              <li className="mb-2 dark:text-dark-text-primary">
                XcelTrip shall provide you (“User”) travel-related information,
                pricing, availability and reservations for airlines, hotels,
                railway, holiday packages, bus and car rentals across the globe
                (“Service/s or XcelTrip Services”). These Services may be
                availed by the User at any time during the year as is offered by
                various third party vendors like airlines, hotels, etc.("Service
                Providers").
              </li>
              <li className="mb-2 dark:text-dark-text-primary">
                This Master User Agreement(“Agreement”)is applicable to all
                Services. In addition to this Agreement and depending on the
                Services opted for by the User, the User shall be required to
                read and accept the relevant terms and conditions of
                service(“TOS”) for each such Service provided by XcelTrip in
                collaboration with various Service Providers, which may be
                updated or modified by XcelTrip from time to time. Such TOS
                shall be deemed to be a part of this Agreement and in the event
                of a conflict between such TOS and this Agreement, the terms of
                this Agreement shall prevail
              </li>
              <li className="mb-2 dark:text-dark-text-primary">
                Services by XcelTrip are offered to the User conditioned on
                acceptance without modification of all the terms, conditions and
                notices contained in this Agreement and the TOS, as may be
                posted on the Website from time to time. For the removal of
                doubts, it is clarified that availing of the Services by the
                User constitutes an acknowledgement and acceptance by the User
                of this Agreement and the TOS. If the User does not agree with
                any part of such terms, conditions and notices, the User must
                not avail XcelTrip Services.
              </li>
              <li className="mb-2 dark:text-dark-text-primary">
                Additionally, the Service Provider itself may provide terms and
                guidelines that govern particular features, offers or the
                operating rules and policies applicable to each Service (for
                example, flights, hotel reservations, packages, etc.). The User
                shall be responsible for ensuring compliance with the terms and
                guidelines or operating rules and policies of the Service
                Provider with whom the User elects to deal, including terms and
                conditions set forth in a Service Providers' fare rules,
                contract of carriage or house rules.
              </li>
            </ol>
            <ul className="flex flex-col gap-4 pl-6 my-6 underline dark:text-dark-text-secondary">
              <li>
                <a href="#1">SECTION 1 - ONLINE PLATFORM TERMS </a>
              </li>
              <li>
                <a href="#2">SECTION 2 - GENERAL CONDITIONS </a>
              </li>
              <li>
                <a href="#3">
                  SECTION 3 - ACCURACY AND COMPLETENESS OF INFORMATION/
                  LIMITATION OF LIABILITY{" "}
                </a>
              </li>
              <li>
                <a href="#4">SECTION 4- ONUS OF THE USER </a>
              </li>
              <li>
                <a href="#5">SECTION 5 - FEE AND PRICE </a>
              </li>
              <li>
                <a href="#6">SECTION 6 - OPTIONAL TOOLS/ WEBSITES </a>
              </li>
              <li>
                <a href="#7">SECTION 7 - THIRD-PARTY LINKS </a>
              </li>
              <li>
                <a href="#8">
                  SECTION 8 - USER COMMENTS AND FEEDBACK, SOLICITATION{" "}
                </a>
              </li>
              <li>
                <a href="#9">SECTION 9 - PERSONAL INFORMATION </a>
              </li>
              <li>
                <a href="#10">SECTION 10 - PROHIBITED USES </a>
              </li>
              <li>
                <a href="#11">SECTION 11 - INDEMNIFICATION</a>
              </li>
              <li>
                <a href="#12">SECTION 12 - RIGHT TO REFUSE</a>
              </li>
              <li>
                <a href="#13">
                  SECTION 13 - RIGHT TO CANCELLATION BY XcelTrip IN CASE OF
                  INVALID INFROMATION FROM USER
                </a>
              </li>
              <li>
                <a href="#14">SECTION 14 INTERPRETATION NUMBER AND GENDER</a>
              </li>
              <li>
                <a href="#15">SECTION 15 – SEVERABILITY</a>
              </li>
              <li>
                <a href="#16">SECTION 16 -– TERMINATION</a>
              </li>
              <li>
                <a href="#17">SECTION 17 - COMPLIANCE WITH LAW.</a>
              </li>
              <li>
                <a href="#18">SECTION 18 - ENTIRE AGREEMENT</a>
              </li>
              <li>
                <a href="#19">SECTION 19 - GOVERNING LAW</a>
              </li>
              <li>
                <a href="#20">SECTION 20 - CONTACT INFORMATION</a>
              </li>
            </ul>

            <p
              id="1"
              className="mb-2 font-semibold dark:text-dark-text-primary"
            >
              SECTION 1 - ONLINE PLATFORM TERMS
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              By availing the services from XcelTrip, it shall be deemed that
              the User has attained the age of majority, has read, understood
              and expressly accepts the terms and conditions of this Agreement,
              and shall be binding on the User. All rights and liabilities of
              the User and/or XcelTrip with respect to any services to be
              provided by XcelTrip shall be restricted to the scope of this
              agreement.
            </p>

            <p
              id="2"
              className="mb-2 font-semibold dark:text-dark-text-primary"
            >
              SECTION 2 - GENERAL CONDITIONS
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              We reserve the right to refuse Service to anyone for any reason at
              any time. The User understands that their content (not including
              credit card information), may be transferred unencrypted and
              involve (a) transmissions over various networks; and (b) changes
              to conform and adapt to technical requirements of connecting
              networks or devices. Credit card information is always encrypted
              during transfer over networks. The User agrees not to reproduce,
              duplicate, copy, sell, resell or exploit any portion of the
              Service, use of the Service, or access to the Service or any
              contact on the website through which the service is provided,
              without express written permission from us. The headings used in
              this agreement are included for convenience only and will not
              limit or otherwise affect these Terms.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip, at its sole discretion reserves the right not to accept
              any order placed by the User through the Website without assigning
              any reason thereof. Any contract to provide any service by
              XcelTrip is not complete until full money towards the service is
              received from the User and accepted by XcelTrip.
            </p>

            <p
              id="3"
              className="mb-2 font-semibold dark:text-dark-text-primary"
            >
              SECTION 3 - ACCURACY AND COMPLETENESS OF INFORMATION/ LIMITATION
              OF LIABILITY
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip has endeavored to ensure that all the information
              provided by it is correct, but XcelTrip neither warrants nor makes
              any representations regarding the quality, accuracy or
              completeness of any data or information. XcelTrip makes no
              warranty, express or implied, concerning the Website and/or its
              contents and disclaims all warranties of fitness for a particular
              purpose and warranties of merchantability in respect of services,
              including any liability, responsibility or any other claim,
              whatsoever, in respect of any loss, whether direct or
              consequential, to any User or any other person, arising out of or
              from the use of any such information.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              To the extent XcelTrip acts only as a booking agent and
              facilitator of Services on behalf of third party service
              providers, it shall not have any liability whatsoever for any
              aspect of the arrangements between the Service Provider and the
              User as regards the standards and rendering of services by the
              Service Providers. In no circumstances shall XcelTrip be liable
              for the services provided by the Service Provider.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Although XcelTrip makes reasonable commercial efforts to ensure
              that the description and content in the TOS and on each page of
              the Website is correct, it does not, however, take responsibility
              for changes that occurred due to human or data entry errors or for
              any loss or damages suffered by any User due to any information
              contained herein.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Also, XcelTrip is not the Service Provider and cannot therefore,
              control or prevent changes in the published descriptions or
              representations, which are always based upon information provided
              by the Service Providers. XcelTrip acts only as a facilitator of
              Services and shall not be held liable for any changes,
              deficiencies, disputes, etc. related to the services being
              provided by Service Providers, including the matters related to
              delays in refunds or no refunds, of the fares and charges paid to
              Service Providers. All refunds to the User/customer on account of
              cancellation of any tickets/services or otherwise shall be made
              subject to receipt of such refunds by XcelTrip from the respective
              Service Provider including Airlines.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip does not endorse any advertiser on its website in any
              manner. The Users are requested to verify the accuracy of all
              information on their own before undertaking any reliance on such
              information.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip does not, by offering travel related services to
              particular destinations, represent or warrant that travel to such
              destinations is without risk, and shall not be liable for damages
              or losses that may result from travel to such destinations.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              In no event shall XcelTrip be liable for any direct, indirect,
              punitive, incidental, special, consequential damages or any other
              damages resulting from: (a) the use or the inability to use the
              services; (b) the cost of procurement of substitute goods and
              services or resulting from any goods, information or services
              purchased or obtained or messages received or transactions entered
              into through the services; (c) unauthorized access to or
              alteration of the User's transmissions or data; (d) any other
              matter relating to the services; including, without limitation,
              damages for loss of use, data or profits, arising out of or in any
              way connected with availing services from XcelTrip.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip shall not be responsible for the delay or inability to
              use/avail the Website or Services, the provision of or failure to
              provide services by Service Provider, or for any information,
              software, products, services and related graphics obtained from
              XcelTrip, whether based on contract, tort, negligence, strict
              liability or otherwise. Further, XcelTrip shall not be held
              responsible for non-availability of the website during periodic
              maintenance operations or any unplanned suspension of access to
              the services that may occur due to technical reasons or for any
              reason beyond XcelTrip's control. The User understands and agrees
              that any material and/or data downloaded or otherwise obtained
              from Website/XcelTrip is done entirely at their own discretion and
              risk and they will be solely responsible for any damage to their
              computer systems or any other loss that results from such material
              and/or data.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              These limitations, disclaimer of warranties and exclusions apply
              without regard to whether the damages arise from (a) breach of
              contract, (b) breach of warranty, (c) negligence, or (d) any other
              cause of action, to the extent such exclusion and limitations are
              not prohibited by applicable law.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The maximum liability on part of XcelTrip arising under any
              circumstances, in respect of any Services availed, shall be
              limited up to a maximum of the refund of total amount received
              from the User/customer for providing the services, less any
              cancellation, refund or others charges, as may be applicable. In
              no case XcelTrip shall be liable for any consequential loss,
              damage or additional expense whatsoever. In no event XcelTrip
              shall be liable for any kind of refunds/returns of
              charges/fee/fares paid to Service Provider for rendering the
              services to the User/customer.
            </p>

            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="4"
            >
              Section 4- ONUS OF THE USER
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip is responsible only for the transactions that are done by
              the User through XcelTrip. XcelTrip will not be responsible for
              screening, censoring or otherwise controlling transactions,
              including whether the transaction is legal and valid as per the
              laws of the land of the User.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User warrants that they will abide by all such additional
              procedures and guidelines, as modified from time to time, in
              connection with the use of the services. The User further warrants
              that they will comply with all applicable laws and regulations
              regarding use of the services with respect to the jurisdiction
              concerned for each transaction.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User represent and confirm that the User is of legal age to
              enter into a binding contract and is not a person barred from
              availing the Services under the laws of Singapore or other
              applicable law.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="5"
            >
              SECTION 5 - FEE AND PRICE
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip reserves the right to charge listing fees for certain
              listings, as well as transaction fees based on certain completed
              transactions using the services. XcelTrip further reserves the
              right to alter any and all fees from time to time, without notice.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip reserves the right to charge listing fees for certain
              listings, as well as transaction fees based on certain completed
              transactions using the services. XcelTrip further reserves the
              right to alter any and all fees from time to time, without notice.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User shall be completely responsible for all charges, fees,
              duties, taxes, and assessments arising out of the use of the
              services.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              In case, there is a short charging by XcelTrip for listing,
              services or transaction fee or any other fee or service because of
              any technical or other reason, it reserves the right to
              deduct/charge/claim the balance subsequent to the transaction at
              its own discretion.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Any increase in the price charged by XcelTrip on account of change
              in rate of taxes or imposition of new taxes by the Government
              shall have to be borne by customer.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              In the rare possibilities of the reservation not getting confirmed
              for any reason whatsoever, we will process the refund and intimate
              the User of the same. XcelTrip is not under any obligation to make
              another booking in lieu of or to compensate/replace the
              unconfirmed one. All subsequent further bookings will be treated
              as new transactions with no reference to the earlier unconfirmed
              reservation.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User shall request XcelTrip for any refunds against the
              unutilized or 'no show' air or hotel booking for any reasons
              within 90 days from the date of departure for the air ticket
              and/or the date of check in for the hotel booking. Any applicable
              refunds would accordingly be processed as per the defined policies
              of the airlines, hotels and XcelTrip as the case may be. No refund
              would be payable for any requests made after the expiry of 90 days
              as above and all unclaimed amounts for such unutilized or 'no
              show' air or hotel booking shall be deemed to have been forfeited.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="6"
            >
              SECTION 6 - OPTIONAL TOOLS/ WEBSITES
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              We may provide the User with access to third-party tools/websites
              over which we neither monitor nor have any control nor input.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User acknowledges and agrees that XcelTrip provide access to
              such tools/websites “as is” and “as available” without any
              warranties, representations or conditions of any kind and without
              any endorsement. We shall have no liability whatsoever arising
              from or relating to the use of optional third-party tools/websites
              by the User.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Any use of optional tools/websites offered through this online
              platform is entirely at the User’s risk and discretion and the
              User should ensure that they are familiar with the third party
              policies and terms of use of such service provider. We may also,
              in the future, offer new services and/or features through the
              website (including, the release of new tools and resources). Such
              new features and/or services shall also be subject to these Terms
              of Service.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Third-party links on our site may direct the User to third-party
              websites that are not affiliated with us. We are not responsible
              for examining or evaluating the content or accuracy and we do not
              warrant and will not have any liability or responsibility for any
              third-party materials or websites, or for any other materials, or
              services of third-parties. We are not liable for any harm or
              damages related to the purchase or use of goods, services,
              resources, content, or any other transactions made in connection
              with any third-party websites. Please review carefully, the
              third-party's policies and practices and make sure to understand
              them before engaging in any transaction. Complaints, claims,
              concerns, or questions regarding third-party products should be
              directed to the third-party.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="7"
            >
              SECTION 7 - THIRD-PARTY LINKS
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              By using the Account in XcelTrip's websites, the User authorizes
              XcelTrip and its agents to access third party sites, including
              that of Banks and other payment gateways, designated by them or on
              their behalf, for retrieving requested information
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              While registering, the User will choose a password and is
              responsible for maintaining the confidentiality of the password
              and the account.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User is fully responsible for all activities that occur while
              using their password or account. It is the duty of the User to
              notify XcelTrip immediately in writing, of any unauthorized use of
              their password or account or any other breach of security.
              XcelTrip will not be liable for any loss that may be incurred by
              the User as a result of unauthorized use of their password or
              account, either with or without their knowledge. The User shall
              not use anyone else's password at any time.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="8"
            >
              SECTION 8 - USER COMMENTS AND FEEDBACK, SOLICITATION{" "}
            </p>
            <ul className="bulleted dark:text-dark-text-secondary">
              The Website may contain services such as email, chat, bulletin
              board services, information related to various tourist spots, news
              groups, forums, communities, personal web pages, calendars, and/or
              other message (hereinafter collectively referred to as
              "Communication Services"). The User agrees and undertakes to use
              the Communication Services only to post, send and receive messages
              and material that are proper and related to the particular
              Communication Service. By way of example, and not as a limitation,
              the User agrees and undertakes that when using a Communication
              Service, the User will not:
              <li>
                Defame, abuse, harass, stalk, threaten or otherwise violate the
                legal rights of others;
              </li>
              <li>
                Publish, post, upload, distribute or disseminate any
                inappropriate, profane, defamatory, infringing, obscene,
                indecent or unlawful topic, name, material or information;
              </li>
              <li>
                Upload files that contain software or other material protected
                by intellectual property laws unless the User owns or controls
                the rights thereto or has received all necessary consents;
              </li>
              <li>
                Upload or distribute files that contain viruses, corrupted
                files, or any other similar software or programs that may damage
                the operation of the Website or another's computer;
              </li>
              <li>
                Advertise or offer to sell or buy any goods or services for any
                business purpose, unless such Communication Service specifically
                allows such messages;
              </li>
              <li>
                conduct or forward surveys, contests, pyramid schemes or chain
                letters;
              </li>
              <li>
                Download any file posted by another User of a Communication
                Service that the User know, or reasonably should know, cannot be
                legally distributed in such manner;
              </li>
              <li>
                Falsify or delete any author attributions, legal or other proper
                notices or proprietary designations or labels of the origin or
                source of software or other material contained in a file that is
                uploaded;
              </li>
              <li>
                Violate any code of conduct or other guidelines, which may be
                applicable for or to any particular Communication Service;
              </li>
              <li>
                Violate any applicable laws or regulations for the time being in
                force in or outside India; and
              </li>
              <li>
                Violate any of the terms and conditions of this Agreement or any
                other terms and conditions for the use of the Website contained
                elsewhere herein.
              </li>
            </ul>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip will review materials posted through Communication
              Service and shall remove any materials, at its sole discretion.
              XcelTrip reserves the right to terminate the User's access to any
              or all of the Communication Services at any time without notice
              for any reason whatsoever.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip reserves the right at all times to disclose any
              information as is necessary to satisfy or comply with any
              applicable law, regulation, legal process or governmental request,
              or to edit, refuse to post or to remove any information or
              materials, in whole or in part, at XcelTrip's sole discretion.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip does not control or endorse the content, messages or
              information found in any Communication Service and, therefore,
              XcelTrip specifically disclaims any liability or responsibility
              whatsoever with regard to the Communication Services and any
              actions resulting from the User's participation in any
              Communication Service.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Materials uploaded to a Communication Service may be subject to
              posted limitations on usage, reproduction and/or dissemination.
              The User is responsible for keeping themselves updated of and
              adhering to such limitations if they download the materials.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              When the User registers with XcelTrip.com, we or any of our
              partners/affiliate/group companies may contact the User from time
              to time to provide offers/information of such products/services
              that we believe may benefit the User.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User is aware that XcelTrip provides various services like
              hotel bookings, car rentals, holidays and would like to learn
              about them, to enhance their travel experience. The User hereby
              specifically authorizes XcelTrip to contact the User with offers
              on various services offered by it, through direct mailers,
              e-mailers, telephone calls, short messaging services (SMS) or any
              other medium, from time to time. In case that the User chooses not
              to be contacted, they shall write to XcelTrip for specific
              exclusion at{" "}
              <a href="mailto:customercare@xceltrip.com">
                customercare@xceltrip.com
              </a>
              or provide their preferences to the respective service provider.
              The Users are advised to read and understand the privacy policy of
              XcelTrip on its website in accordance of which XcelTrip contacts,
              solicits the User or shares the User's information.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="9"
            >
              SECTION 9 - PERSONAL INFORMATION
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User’s submission of personal information through the online
              platform is governed by XcelTrip’s Privacy Policy.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="10"
            >
              SECTION 10 - PROHIBITED USES
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              In addition to other prohibitions as set forth in the Terms of
              Service, the User is prohibited from using the site or its
              content: (a) for any unlawful purpose; (b) to solicit others to
              perform or participate in any unlawful acts; (c) to violate any
              international, federal, provincial or state regulations, rules,
              laws, or local ordinances; (d) to infringe upon or violate our
              intellectual property rights or the intellectual property rights
              of others; (e) to harass, abuse, insult, harm, defame, slander,
              disparage, intimidate, or discriminate based on gender, sexual
              orientation, religion, ethnicity, race, age, national origin, or
              disability; (f) to submit false or misleading information; (g) to
              upload or transmit viruses or any other type of malicious code
              that will or may be used in any way that will affect the
              functionality or operation of the Service or of any related
              website, other websites, or the Internet; (h) to collect or track
              the personal information of others; (i) to spam, phish, pharm,
              pretext, spider, crawl, or scrape; (j) for any obscene or immoral
              purpose; or (k) to interfere with or circumvent the security
              features of the Service or any related website, other websites, or
              the Internet. We reserve the right to terminate the User’suse of
              the Service or any related website for violating any of the
              prohibited uses.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="11"
            >
              SECTION 11 - INDEMNIFICATION
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User agrees to indemnify, defend and hold harmless XcelTrip
              and its parent, subsidiaries, affiliates, partners, officers,
              directors, agents, contractors, licensors, service providers,
              assigns, subcontractors, suppliers, interns and employees,
              harmless against all losses, claim or demand, liabilities,
              damages, costs and expenses (including reasonable attorneys’ fees
              and disbursements in connection therewith and interest chargeable
              thereon), made by any third-party due to or arising out of the
              User’s breach of these Terms of Service or non-performance of any
              representation, warranty, covenant or agreement made or obligation
              to be performed by the User pursuant to this agreement.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The user shall be solely and exclusively liable for any breach of
              any country specific rules and regulations or general code of
              conduct and XcelTrip cannot be held responsible for the same.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="12"
            >
              SECTION 12 - RIGHT TO REFUSE
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip, at its sole discretion, reserves the right to not accept
              any customer order without assigning any reason thereof. Any
              contract to provide any service by XcelTrip is not complete until
              full money towards the service is received from the customer and
              accepted by XcelTrip.
            </p>
            <ul className="bulleted dark:text-dark-text-secondary">
              Without prejudice to the other remedies available to XcelTrip
              under this agreement, the TOS or under applicable law, XcelTrip
              may limit the User's activity, or end the User's listing, warn
              other Users of the User's actions, immediately
              temporarily/indefinitely suspend or terminate the User's
              registration, and/or refuse to provide the User with access to the
              website if:
              <li>
                The User is in breach of this agreement, the TOS and/or the
                documents it incorporates by reference;
              </li>
              <li>
                XcelTrip is unable to verify or authenticate any information
                provided by the User; or
              </li>
              <li>
                XcelTrip believes that the User's actions may infringe on any
                third party rights or breach any applicable law or otherwise
                result in any liability for the User, other Users of the website
                and/or XcelTrip.
              </li>
            </ul>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip may at any time, at its sole discretion, reinstate
              suspended users. Once the User has been indefinitely suspended,
              the User shall not register or attempt to register with XcelTrip
              or use the website in any manner whatsoever until such time that
              the User is reinstated by XcelTrip.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Notwithstanding the foregoing, if the User breaches this
              agreement, the TOS or the documents it incorporates by reference,
              XcelTrip reserves the right to recover any amounts due and owing
              by the User to XcelTrip and/or the service provider and to take
              strict legal action as XcelTrip deems necessary.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="13"
            >
              SECTION 13 – RIGHT TO CANCELLATION BY XcelTrip IN CASE OF INVALID
              INFROMATION FROM USER
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User expressly undertakes to provide to XcelTrip only correct
              and valid information while requesting for any services under this
              agreement, and not to make any misrepresentation of facts at all.
              Any default on part of the User would vitiate this agreement and
              shall disentitle the User from availing the services from
              XcelTrip.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              In case XcelTrip discovers or has reasons to believe, at any time
              during or after receiving a request for services from the User,
              that the request for services is either unauthorized or the
              information provided by the User or any of them is not correct or
              that any fact has been misrepresented by them, XcelTrip at its
              sole discretion, shall have the unrestricted right to take any
              steps against the User(s), including cancellation of the bookings,
              etc. without any prior intimation to the User. In such an event,
              XcelTrip shall not be responsible or liable for any loss or damage
              that may be caused to the User or any of them as a consequence of
              such cancellation of booking or services.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User unequivocally indemnifies XcelTrip of any such claim or
              liability and shall not hold XcelTrip responsible for any loss or
              damage arising out of measures taken by XcelTrip for safeguarding
              its own interest and that of its genuine customers. This would
              also include XcelTrip denying/cancelling any bookings on account
              of suspected fraud transactions.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="14"
            >
              SECTION 14 – INTERPRETATION NUMBER AND GENDER
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The terms and conditions herein shall apply equally to both the
              singular and plural form of the terms defined. Whenever the
              context may require, any pronoun shall include the corresponding
              masculine, feminine and neuter form. The words "include",
              "includes" and "including" shall be deemed to be followed by the
              phrase "without limitation". Unless the context otherwise
              requires, the terms "herein", "hereof", "hereto", 'hereunder" and
              words of similar import refer to this agreement as a whole.
            </p>
            <p className="text-sm dark:text-dark-text-secondary ">
              The terms and conditions herein shall apply equally to both the
              singular and plural form of the terms defined. Whenever the
              context may require, any pronoun shall include the corresponding
              masculine, feminine and neuter form. The words "include",
              "includes" and "including" shall be deemed to be followed by the
              phrase "without limitation". Unless the context otherwise
              requires, the terms "herein", "hereof", "hereto", 'hereunder" and
              words of similar import refer to this agreement as a whole.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="15"
            >
              SECTION 15 – SEVERABILITY
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              In the event that any provision of this Agreement is determined to
              be unlawful, void or unenforceable, such provision shall
              nonetheless be enforceable to the fullest extent permitted by
              applicable law, and the unenforceable portion shall be deemed to
              be severed from this Agreement. Such determination shall not
              affect the validity and enforceability of any other remaining
              provisions.
            </p>

            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="16"
            >
              SECTION 16 -– TERMINATION
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Either the User or XcelTrip may terminate this Agreement and
              Service with or without cause, at any time, to be effective
              immediately.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              The User agrees that XcelTrip may under certain circumstances and
              without prior notice, may immediately terminate the User's id and
              access to the Website/Services. Causes for termination may
              include, but shall not be limited to, breach by the User of this
              Agreement or the TOS, requests by enforcement or government
              agencies, requests by the User, non-payment of fees owed by the
              User in connection with the Services as specified in the
              applicable TOS.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              This Agreement may be terminated by either the User or XcelTrip
              through a written notice to the other. XcelTrip shall not be
              liable to the User or any third party for termination of any
              Service. Should the User object to any terms and conditions of
              this Agreement, any TOS or become dissatisfied with the Service in
              any way, the User's only recourse is to immediately: (a)
              discontinue use of the Website/Service; and (b) notify XcelTrip of
              such discontinuance.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Upon termination of the Service, the User's right to use the
              Website/Services and software shall immediately cease. The User
              shall have no right and XcelTrip shall have no obligation
              thereafter to execute any of the User's uncompleted tasks or
              forward any unread or unsent messages to the User or any third
              party. Once the User's registration or the Services are
              terminated, cancelled or suspended, any data that the User has
              stored on the Website may not be retrieved later.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="17"
            >
              SECTION 17 - COMPLIANCE WITH THE LAW
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              XcelTrip shall strictly comply with all applicable laws. XcelTrip,
              its employees and any sub-contractor retained shall be bound by
              XcelTrip Anti-Bribery Policy, Supplier Code of Conduct, OTA Refund
              &amp; Cancellation policy/ OTA Privacy Policy/ OTA Pricing Policy,
              and any other policies and guidelines that may be provided by
              XcelTrip from time to time. (Provide the Link of Policies)
              XcelTrip hereby confirms that it has read and understood the above
              mentioned policies and guidelines and shall perform its
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="18"
            >
              SECTION 18 - ENTIRE AGREEMENT
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Any failure by us to exercise or enforce any right or provision of
              this Agreement Service shall not constitute a waiver of such right
              or provision.
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              This Agreement and any policies or operating rules posted by us on
              this website or in respect to the Service constitutes the entire
              agreement and understanding between you and us and govern your use
              of the Service, superseding any prior or contemporaneous
              agreements, communications and proposals, whether oral or written,
              between you and us (including, but not limited to, any prior
              versions of the Agreement, if any).
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Any ambiguities in the interpretation of this Agreement shall not
              be construed against the drafting party.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="19"
            >
              SECTION 19 - GOVERNING LAW
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              This Agreement and any separate agreements whereby we provide you
              Services shall be governed by and construed in accordance with the
              laws of Singapore.
            </p>
            <p
              className="mb-2 font-semibold dark:text-dark-text-primary"
              id="20"
            >
              SECTION 20 - CONTACT INFORMATION
            </p>
            <p className="text-sm dark:text-dark-text-secondary">
              Questions about the Terms of Service should be sent to us at
              <a href="milto:customercare@xceltrip.com.">
                customercare@xceltrip.com.
              </a>{" "}
              This document was updated in June 2018
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsAndConditions;
